import React, { useState } from "react";
import { DateTime } from "luxon";
import ModaleLocale from "../../common/CustomModal/ModaleLocale";
import { aujourdhui, pluriel } from "./reglesSousOrientation";
import { preparerVersion } from "./reglesSousOrientationApi";

// ============================================================
// Préparer une version des règles (CE-1419) : une date d'effet, aujourd'hui
// au plus tôt ; la version reprend les règles de celle en vigueur. Sans
// aucune version, la première se crée vide, datée d'aujourd'hui par défaut ;
// sinon le 1er janvier qui suit est proposé (règles d'une nouvelle année).
// Le refus de l'API s'affiche sous la date (400) ou en bandeau (409).
// ============================================================

const ModaleVersion = ({ premiere, nombreRegles, onFermer, onPreparee }) => {
  const jour = aujourdhui();
  const [enVigueurLe, setEnVigueurLe] = useState(() => (premiere ? jour : DateTime.fromISO(jour).plus({ years: 1 }).startOf("year").toISODate()));
  const [erreur, setErreur] = useState(null);
  const [refus, setRefus] = useState(null);
  const [enCours, setEnCours] = useState(false);

  const enregistrer = (e) => {
    e.preventDefault();
    setErreur(null);
    setRefus(null);
    if (!enVigueurLe) {
      setErreur("Indiquez la date à partir de laquelle la version s'applique.");
      return;
    }
    setEnCours(true);
    preparerVersion(enVigueurLe)
      .then(onPreparee)
      .catch((echec) => {
        setEnCours(false);
        if (echec.champs) setErreur(echec.champs.enVigueurLe || Object.values(echec.champs)[0]);
        else setRefus(echec.message);
      });
  };

  return (
    <ModaleLocale
      ouvert
      onFermer={onFermer}
      titre={premiere ? "Créer la première version" : "Préparer une version"}
      taille="etroite"
      idTitre="modale-version"
      peutFermer={!enCours}
      pied={
        <>
          <button type="button" className="btn btn-ghost" onClick={onFermer} disabled={enCours}>
            Annuler
          </button>
          <button type="submit" form="formulaire-version" className="btn btn-primary" disabled={enCours}>
            {premiere ? "Créer la version" : "Préparer la version"}
          </button>
        </>
      }
    >
      <form id="formulaire-version" onSubmit={enregistrer} noValidate>
        {refus && (
          <div className="alert alert-danger" role="alert">
            {refus}
          </div>
        )}
        <p className="saisie-regle__aide mt-0">
          {premiere
            ? "La version commence sans règle : ajoutez-les ensuite. Datée d'aujourd'hui, elle s'applique tout de suite."
            : `Elle reprend ${nombreRegles ? `les ${pluriel(nombreRegles, "règle")} de la version en vigueur` : "la version en vigueur, qui n'a pas de règle"} ; vous la modifiez ensuite sans toucher à celle-ci. Elle s'appliquera à sa date d'effet.`}
        </p>
        <div className="saisie-regle__champ">
          <label htmlFor="version-date">Date d'effet</label>
          <input
            id="version-date"
            type="date"
            className="form-control saisie-regle__date"
            min={jour}
            value={enVigueurLe}
            onChange={(e) => setEnVigueurLe(e.target.value)}
            aria-invalid={erreur ? "true" : undefined}
            aria-describedby={erreur ? "erreur-version-date" : undefined}
          />
          {erreur && (
            <p className="saisie-regle__erreur" id="erreur-version-date" role="alert">
              {erreur}
            </p>
          )}
        </div>
      </form>
    </ModaleLocale>
  );
};

export default ModaleVersion;
